/** @type {import('rollbar').Configuration} */
export const rollbarConfig = {
  accessToken: 'e754942ce4a34e37870ebb4f0d8f871a',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV !== 'development',
};
